"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lceSelect = void 0;
const models_1 = require("./models");
/**
 * Runs the function in @param options that matches the state of @param lce.
 */
function lceSelect(lce, options) {
    let handler;
    switch (lce.type) {
        case models_1.LCEType.NotRequested:
            handler = options.isNotRequested;
            break;
        case models_1.LCEType.Fetching:
            handler = options.isFetching;
            break;
        case models_1.LCEType.Content:
            handler = options.content;
            break;
        case models_1.LCEType.Error:
            handler = options.error;
            break;
    }
    handler = handler !== null && handler !== void 0 ? handler : options.default;
    return handler === null || handler === void 0 ? void 0 : handler(lce);
}
exports.lceSelect = lceSelect;
//# sourceMappingURL=select.js.map